import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=95504ae6&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=95504ae6&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95504ae6"]])

export default __exports__